import { useKeenSlider } from 'keen-slider/react';
import { useState } from 'react';
import StarRating from '../../images/marketing/star_filled.webp';

//updated version

const Testimonials = [
  {
    headline: "Best lender I've ever had.",
    quote:
      'Very communicative, quick, and easy to get a hold of when you need to. I like that you can see exactly what step everything is on on their site. They seemed to always be on top of their stuff. Highly recommend.',
    author: 'Lindsey S.',
  },
  {
    headline: 'I cannot say enough good things.',
    quote:
      'The ease of the website, the on-time information, the helpful staff....everything was just perfect!',
    author: 'Paula P.',
  },
  {
    headline: 'Thanks to Morty!',
    quote:
      'The Mortgage Advisor I worked with was Phillip and he was extremely knowledgeable. It was such a relief to have my mortgage loan handled by Morty so I could focus on other parts of home buying knowing my loan was in good hands.',
    author: 'Nathalie S.',
  },
  {
    headline: 'Morty was awesome!',
    quote:
      'They offered us the best deal (and I shopped around a lot). Their mortgage calculator tool was easy and useful. Their closing checklist was straightforward and very helpful. Their team was super responsive to all my emails.',
    author: 'Lara D.',
  },
  {
    headline: 'Strongly recommend Morty.',
    quote:
      'Fast service, professional, low rates. I will never shop for a loan elsewhere.',
    author: 'Phi T.',
  },
  {
    headline: 'So helpful, knowledgeable and patient.',
    quote:
      'We definitely recommend Morty! The whole Morty team worked diligently to get us in our new home in just 23 days! We are extremely grateful!!',
    author: 'Ryan and Beth F',
  },
  {
    headline: 'Excellent guidance.',
    quote:
      'Buying your first home is such a huge deal, and he very much treated it as such. We are grateful for the support, and could not recommend Morty or working with Derek in general as well!!!',
    author: 'Nicole S.',
  },
  {
    headline: 'Morty is great!',
    quote:
      'They truly made the process easy. The rates and fees you see in the portal are accurate and do not change. The closing team is super responsive and helpful along with always making sure that we were cleared to close long before the closing date.',
    author: 'Derek and Liza',
  },
  {
    headline: 'Great experience working with Morty!',
    quote:
      'Then they were extremely helpful throughout the process. Everything went smoothly with them from start of application to closing.',
    author: 'Elizabeth L',
  },
  {
    headline: 'Great team of professionals.',
    quote:
      'Got the chance to work with very helpful and knowledgeable people. I highly recommends Morty',
    author: 'Leo',
  },
  {
    headline: ' Boy did they deliver.',
    quote:
      "I'm SOLD on Morty. They followed me all the way to closing and their online stage-by-stage guide was very easy to understand and I could do 100% by online signature. GAME CHANGER!",
    author: 'Israel K',
  },
  {
    headline: 'Highly highly recommend.',
    quote:
      'Morty was an awesome partner in buying our home! Ebony went above and beyond to ease my stress over the weekend!!',
    author: 'Tammy B',
  },
  {
    headline: 'Amazing experience with Morty',
    quote:
      ' I needed to get the closing in a very short time and the whole team at Morty completed that ambitious goal in record time!!! I highly approve of Morty',
    author: 'Yasir T',
  },
  {
    headline: 'You are the best!',
    quote:
      ' Morty offered the most competitive rate, great loan origination process and communications were to the T. As a buyer I was super confident in every step of the way.',
    author: 'Hari R',
  },
  {
    headline: 'Highly recommend Morty!',
    quote:
      'We were always able to count on the reliability and promptness of the Morty team to help us through the finish line. The loan process was actually the most smooth part of our real estate transaction.',
    author: 'Andrew',
  },
  {
    headline: 'Morty is the best!',
    quote:
      'The team we worked with was outstanding. Flawless customer support that other companies only aspire to achieve. We appreciated their patience, responsiveness, and assistance every step of the way.',
    author: 'Alexander P',
  },
];

interface Testimonial {
  body: string;
  author: string;
  fontClassName?: string;
}

function TestimonialSlide(props: {
  headline: string;
  quote: string;
  author: string;
}) {
  return (
    <div className="keen-slider__slide">
      <div className="border border-hardwood-700 rounded flex h-full w-full flex-col space-y-4 px-6 py-8 md:h-96 md:w-72 xl:h-78 xl:w-78">
        <div className="flex flex-row space-x-2">
          <img
            className="w-4"
            src={StarRating}
            height="50"
            width="50"
            alt="star"
          />
          <img
            className="w-4"
            src={StarRating}
            height="50"
            width="50"
            alt="star"
          />
          <img
            className="w-4"
            src={StarRating}
            height="50"
            width="50"
            alt="star"
          />
          <img
            className="w-4"
            src={StarRating}
            height="50"
            width="50"
            alt="star"
          />
          <img
            className="w-4"
            src={StarRating}
            height="50"
            width="50"
            alt="star"
          />
        </div>
        <h3 className="text-heading-3">{props.headline}</h3>
        <p className="text-body-small">{props.quote}</p>
        <p className="text-eyebrow">-{props.author}</p>
      </div>
    </div>
  );
}

function Arrow(props: {
  disabled: boolean;
  left?: boolean;
  onClick: (e: any) => void;
  fill: string;
}) {
  const disabled = props.disabled ? ' arrow--disabled' : '';
  return (
    <svg
      onClick={props.onClick}
      className={`arrow ${
        props.left ? 'arrow--left' : 'arrow--right'
      } ${disabled} h-[12px w-[12px] fill-[${
        props.fill
      }] pointer-events-auto cursor-pointer`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      {props.left && (
        <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
      )}
      {!props.left && (
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
      )}
    </svg>
  );
}

export function CompanyTestimonials(props: {}) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(true);

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>(
    {
      slides: {
        perView: 3,
        spacing: 10,
      },
      initial: 0,
      loop: true,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {},
      breakpoints: {
        '(max-width: 1000px)': {
          slides: {
            perView: 2,
            spacing: 10,
          },
        },
        '(max-width: 600px)': {
          slides: {
            perView: 1,
          },
        },
      },
    },
    [
      (slider) => {
        let timeout: number;
        let mouseOver = false;
        function clearNextTimeout() {
          clearTimeout(timeout);
        }
        function nextTimeout() {
          clearTimeout(timeout);
          if (mouseOver) return;
          // @ts-ignore
          timeout = setTimeout(() => {
            slider.next();
          }, 10000);
        }
        slider.on('created', () => {
          slider.container.addEventListener('mouseover', () => {
            mouseOver = true;
            clearNextTimeout();
          });
          slider.container.addEventListener('mouseout', () => {
            mouseOver = false;
            nextTimeout();
          });
          nextTimeout();
        });
        // slider.on("dragStarted", clearNextTimeout);
        // slider.on("animationEnded", nextTimeout);
        // slider.on("updated", nextTimeout);
      },
    ]
  );

  return (
    <div className="flex items-center justify-center">
      <div
        className="group relative flex w-full cursor-pointer px-16"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          ref={sliderRef}
          className="keen-slider absolute left-0 top-0 h-full w-full"
        >
          {Testimonials.map((step, idx) => {
            return (
              <TestimonialSlide
                key={idx}
                headline={step.headline}
                quote={step.quote}
                author={step.author}
              />
            );
          })}
        </div>
        <div
          className={`arrows pointer-events-none absolute left-0 top-0 flex h-full w-full items-center justify-between px-4`}
        >
          <Arrow
            left
            onClick={() => {
              instanceRef?.current?.prev();
            }}
            disabled={currentSlide === 0}
            fill={'#212121'}
          ></Arrow>
          <Arrow
            onClick={() => {
              instanceRef?.current?.next();
            }}
            disabled={
              instanceRef?.current
                ? currentSlide ===
                  instanceRef?.current?.track.details?.slides.length - 1
                : false
            }
            fill={'#212121'}
          ></Arrow>
        </div>
      </div>
    </div>
  );
}
